import React from "react";
import Navbar from "../../Navbar/Navbar";
import Bredcom from "../../Bredcom/Bredcom";
import Footer from "../../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OsnivacPage = () => {
  // kompatibilno i sa starijim i sa novijim react-i18next return shape
  const tr = useTranslation();
  const t = Array.isArray(tr) ? tr[0] : tr.t;

  const toc = [
    { href: "#bio", label: t("osnivac.tocBio") },
    { href: "#vision", label: t("osnivac.tocVision") },
    { href: "#model", label: t("osnivac.tocModel") },
    { href: "#remember", label: t("osnivac.tocRemember") },
    { href: "#today", label: t("osnivac.tocToday") },
  ];

  const quickLinks = [
    {
      to: "/o-fpep",
      label: t("osnivac.linksAbout"),
      icon: "fas fa-university",
    },
    {
      to: "/akreditacija-fpep",
      label: t("osnivac.linksAccred"),
      icon: "fas fa-certificate",
    },
    {
      to: "/svi-studijski-programi",
      label: t("osnivac.linksPrograms"),
      icon: "fas fa-book-open",
    },
    {
      to: "/erasmus",
      label: t("osnivac.linksErasmus"),
      icon: "fas fa-globe-europe",
    },
    {
      to: "/kontakt",
      label: t("osnivac.linksContact"),
      icon: "fas fa-envelope",
    },
  ];
  const quoteIds = [1, 2, 3, 4, 5, 6];

  const quotes = quoteIds
    .map((id) => {
      const textKey = `osnivac.quote${id}.text`;
      const byKey = `osnivac.quote${id}.by`;

      const text = t(textKey);
      if (text === textKey) return null; // nema prevoda -> preskoči

      return { id, text, by: t(byKey) };
    })
    .filter(Boolean);

  return (
    <>
      <Navbar />

      <Bredcom title={t("breadcrumb.home")} subtitle={t("fpep.osnivac")} />

      <main
        className="osnivac-page container my-4 pt-40"
        aria-label={t("osnivac.aria")}
      >
        {/* HERO / MEMORIAL CARD */}
        <section className="osnivac-hero" aria-label={t("osnivac.heroAria")}>
          <div className="osnivac-hero__grid">
            <div className="osnivac-hero__media">
              <img
                src="/assets/img/bg/osnivac-fpep.webp"
                alt={t("osnivac.photoAlt")}
                className="osnivac-hero__img"
                loading="lazy"
              />
            </div>

            <div className="osnivac-hero__content">
              <div className="osnivac-badge">
                {t("osnivac.memorialEyebrow")}
              </div>

              <h1 className="osnivac-title">{t("osnivac.memorialTitle")}</h1>

              <div className="osnivac-sub">
                <span className="osnivac-sub__role">
                  {t("osnivac.memorialRole")}
                </span>
                <span className="osnivac-sub__dot">•</span>
                <span className="osnivac-sub__dates">
                  {t("osnivac.memorialDates")}
                </span>
              </div>

              <p className="osnivac-lead">{t("osnivac.memorialLead")}</p>

              {/* TOC */}
              <nav className="osnivac-toc" aria-label={t("osnivac.tocAria")}>
                <div className="osnivac-toc__title">
                  {t("osnivac.tocTitle")}
                </div>
                <div className="osnivac-toc__links">
                  {toc.map((item) => (
                    <a
                      key={item.href}
                      href={item.href}
                      className="osnivac-toc__link"
                    >
                      {item.label}
                    </a>
                  ))}
                </div>
              </nav>
            </div>
          </div>
        </section>

        {/* BIOGRAPHY (existing text preserved) */}
        <section
          id="bio"
          className="osnivac-section"
          aria-label={t("osnivac.sectionBioAria")}
        >
          <h2 className="osnivac-section__title">
            {t("osnivac.section.bioTitle")}
          </h2>

          {/* OVO JE POSTOJEĆI TEKST – NE MIJENJAMO GA */}
          <p className="founder-paragraph">{t("osnivac.p1")}</p>
          <p className="founder-paragraph">{t("osnivac.p2")}</p>
          <p className="founder-paragraph">{t("osnivac.p3")}</p>
        </section>

        {/* VISION */}
        <section
          id="vision"
          className="osnivac-section"
          aria-label={t("osnivac.sectionVisionAria")}
        >
          <h2 className="osnivac-section__title">
            {t("osnivac.section.visionTitle")}
          </h2>

          <p className="founder-paragraph">{t("osnivac.section.visionP1")}</p>
          <p className="founder-paragraph">{t("osnivac.section.visionP2")}</p>
        </section>

        {/* PRACTICAL MODEL */}
        <section
          id="model"
          className="osnivac-section"
          aria-label={t("osnivac.sectionModelAria")}
        >
          <h2 className="osnivac-section__title">
            {t("osnivac.section.modelTitle")}
          </h2>

          <p className="founder-paragraph">{t("osnivac.section.modelP1")}</p>

          <div className="osnivac-steps">
            <div className="osnivac-steps__title">
              {t("osnivac.section.modelStepsTitle")}
            </div>
            <ul className="osnivac-steps__list">
              <li>{t("osnivac.section.modelStep1")}</li>
              <li>{t("osnivac.section.modelStep2")}</li>
              <li>{t("osnivac.section.modelStep3")}</li>
              <li>{t("osnivac.section.modelStep4")}</li>
              <li>{t("osnivac.section.modelStep5")}</li>
            </ul>
          </div>
        </section>

        {/* REMEMBER / QUOTES */}
        <section
          id="remember"
          className="osnivac-section"
          aria-label={t("osnivac.sectionRememberAria")}
        >
          <h2 className="osnivac-section__title">
            {t("osnivac.section.rememberTitle")}
          </h2>

          <p className="founder-paragraph">
            {t("osnivac.section.rememberLead")}
          </p>

          <div className="osnivac-quotes" role="list">
            {quotes.map((q) => (
              <figure key={q.id} className="osnivac-quote" role="listitem">
                <blockquote className="osnivac-quote__text">
                  {q.text}
                </blockquote>
                <figcaption className="osnivac-quote__by">{q.by}</figcaption>
              </figure>
            ))}
          </div>

          <p className="founder-paragraph osnivac-muted">
            {t("osnivac.section.rememberP2")}
          </p>
        </section>

        {/* TODAY / FACULTY NAME + LAW */}
        <section
          id="today"
          className="osnivac-section"
          aria-label={t("osnivac.sectionTodayAria")}
        >
          <h2 className="osnivac-section__title">
            {t("osnivac.section.todayTitle")}
          </h2>

          <p className="founder-paragraph">{t("osnivac.section.todayP1")}</p>
          <p className="founder-paragraph">{t("osnivac.section.todayP2")}</p>

          <div className="osnivac-links" aria-label={t("osnivac.linksAria")}>
            <div className="osnivac-links__title">
              {t("osnivac.linksTitle")}
            </div>
            <div className="osnivac-links__row">
              {quickLinks.map((l) => (
                <Link key={l.to} to={l.to} className="osnivac-link">
                  <i className={l.icon} aria-hidden="true" />
                  <span>{l.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* SIGNATURE */}
        <div
          className="osnivac-signature"
          aria-label={t("osnivac.signatureAria")}
        >
          <div className="osnivac-signature__name">Prof. dr Božo Marđokić</div>
          <div className="osnivac-signature__dates">
            02.06.1937. – 03.04.2018.
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default OsnivacPage;
